import { AVATAR_SIZE } from '../../components/Constants';
import { userAPI } from '../../context/user';
import { useAuthDispatch } from '../../context/auth';
import { useEnvDispatch, useEnvState } from '../../context/env';
import { categoriesAPI, useCategoriesDispatch } from '../../context/categories';
const forumInterfaceFunctions = (props, setters) => {
  // props
  const platformUser = props.user;
  const revokeDiscourseAPIKey = props.revokeDiscourseAPIKey;
  const refreshToken = props.refreshToken;
  const dispatchForumCommunicationPreferences = props.dispatchForumCommunicationPreferences;
  let authDispatch, categoriesDispatch, envState, envDispatch;
  let setShowLoginScreen, setShowSpinner, setTokenRefreshed;
  if (setters) {
    // context
    authDispatch = useAuthDispatch();
    categoriesDispatch = useCategoriesDispatch();
    envState = useEnvState();
    envDispatch = useEnvDispatch();
    // setters
    setShowLoginScreen = setters.setShowLoginScreen;
    setShowSpinner = setters.setShowSpinner;
    setTokenRefreshed = setters.setTokenRefreshed;
  }
  const setEnvironmentVars = env => {
    try {
      // set env vars
      envDispatch({
        type: 'SET_BASE_URL',
        payload: env.FORUM_BASE_URL
      });
      envDispatch({
        type: 'SET_API_URL',
        payload: env.FORUM_API_URL
      });
      envDispatch({
        type: 'SET_DISCOURSE_API_USERNAME_PREFIX',
        payload: env.FORUM_DISCOURSE_API_USERNAME_PREFIX
      });
      envDispatch({
        type: 'SET_GROUP_PM_OPTED_OUT_ID',
        payload: env.FORUM_GROUP_PM_OPTED_OUT_ID
      });
      envDispatch({
        type: 'SET_GROUP_PM_OPTED_OUT_NAME',
        payload: env.FORUM_GROUP_PM_OPTED_OUT_NAME
      });
      envDispatch({
        type: 'SET_PRODUCT',
        payload: env.PRODUCT
      });
      envDispatch({
        type: 'SET_IS_OUTSIDE_FORUM',
        payload: env.IS_OUTSIDE_FORUM
      });
    } catch (e) {
      console.log('Environment NOT set up');
    }
  };

  // auth by platform after token refresh
  const authPlatformUser = async () => {
    const authenticateByPlatformUser = await setAuthContextFromPlatformUser();
    if (!authenticateByPlatformUser) {
      // console.log('user will need to use login form to authenticate');
      if (setShowLoginScreen) {
        setShowLoginScreen(true);
      } else {
        return false;
      }
    }
  };
  const authenticateUser = async () => {
    const authenticateByPlatformUser = await setAuthContextFromPlatformUser();
    // console.log('authenticateByPlatformUser auth succeeded', authenticateByPlatformUser);
    if (!authenticateByPlatformUser) {
      const authenticateByRefreshedToken = await setAuthContextFromRefreshedToken();
      // console.log('authenticateByRefreshedToken', authenticateByRefreshedToken);
      if (authenticateByRefreshedToken === true) {
        // console.log('set tokenRefreshed to true');
        setTokenRefreshed(true);
      } else {
        // console.log('user will need to use login form to authenticate');
        setShowLoginScreen(true);
      }
    }
    setShowSpinner(false);
  };
  const setAuthContextFromPlatformUser = async () => {
    const res = await setAuthContextFromUser(platformUser);
    return res;
  };
  const setAuthContextFromRefreshedToken = async () => {
    const revokeResponse = await revokeDiscourseAPIKey();
    if (!!(revokeResponse !== null && revokeResponse !== void 0 && revokeResponse.success) === true) {
      const refreshResponse = await refreshToken();
      return refreshResponse;
    } else {
      return false;
    }
  };
  const setAuthContextFromUser = async (user, extProps) => {
    let isAuthenticated = false;
    let stateResource = extProps ? extProps : envState;
    if (user && user.discourseKey && user.userId) {
      const authUserName = `${stateResource.discourse_api_username_prefix}.${user.userId}`;
      const res = await userAPI.getUser(stateResource.base_url, authUserName, user.discourseKey);
      if (res && res.user && res.user.id && res.user.name) {
        const discourseUser = res.user;

        /* pluck out user options to set communication preferences in embedding library
         * if the function is defined */
        let forumCommunicationPreferences = _.pick(discourseUser.user_option, ['email_digests', 'email_level', 'email_messages_level', 'digest_after_minutes', 'allow_private_messages']);
        let userProductGroups = discourseUser.groups.filter(g => !g.automatic);
        forumCommunicationPreferences.userProductGroups = userProductGroups;
        dispatchForumCommunicationPreferences && dispatchForumCommunicationPreferences(forumCommunicationPreferences);
        stateResource.setForum && stateResource.setForum(forumCommunicationPreferences);
        stateResource.setInitialForum && stateResource.setInitialForum(forumCommunicationPreferences);
        if (!extProps) {
          let avatar = user.avatarUrl ? user.avatarUrl : null;
          authDispatch({
            type: 'SET_DISCOURSE_USER_ID',
            payload: discourseUser.id
          });
          authDispatch({
            type: 'SET_USER_NAME',
            payload: discourseUser.name
          });
          authDispatch({
            type: 'SET_MODERATOR',
            payload: discourseUser.moderator
          });
          if (!avatar && discourseUser.avatar_template) {
            avatar = stateResource.base_url + discourseUser.avatar_template.replace(/\{size\}/, AVATAR_SIZE); // set avatar from discourse
          }

          authDispatch({
            type: 'SET_API_KEY',
            payload: user.discourseKey
          });
          authDispatch({
            type: 'SET_PLATFORM_USER_ID',
            payload: user.userId
          });
          authDispatch({
            type: 'SET_AUTH_USER_AVATAR',
            payload: avatar
          });
          authDispatch({
            type: 'SET_USER_AUTHENTICATED',
            payload: true
          });
          authDispatch({
            type: 'SET_PLATFORM_USER',
            payload: platformUser
          });
        }
        isAuthenticated = true;
      }
    }
    return isAuthenticated;
  };
  const setUserPreferences = async (user, extProps, data) => {
    let success = false;
    let stateResource = extProps ? extProps : envState;
    if (user && user.discourseKey && user.userId) {
      const authUserName = `${stateResource.discourse_api_username_prefix}.${user.userId}`;
      const res = await userAPI.putUser(stateResource.base_url, authUserName, data, user.discourseKey);
      if (res && res.success === 'OK') {
        success = true;
      }
    }
    return success;
  };
  const getUserUnsubscribeOptions = async (user, extProps) => {
    let stateResource = extProps ? extProps : envState;
    if (user && user.discourseKey) {
      const res = await userAPI.getUserUnsubscribe(stateResource.base_url, stateResource.unsubscribeKey, user.discourseKey);
      if (res && res.success === 'OK') {
        return res;
      }
    }
    return {};
  };
  const setUserUnsubscribeOptions = async (user, extProps, data) => {
    let success = false;
    let stateResource = extProps ? extProps : envState;
    if (user && user.discourseKey && user.userId) {
      const res = await userAPI.postUserUnsubscribe(stateResource.base_url, stateResource.unsubscribeKey, data, user.discourseKey);
      if (res && ['OK', true].includes(res.success)) {
        success = true;
      }
    }
    return success;
  };
  const setCategories = async () => {
    let productCategories = await categoriesAPI.getCategories(envState.base_url, platformUser.discourseKey, props.product);
    if (productCategories && !Array.isArray(productCategories)) {
      productCategories = [productCategories];
    }
    if (categoriesDispatch && productCategories && productCategories.length) {
      categoriesDispatch({
        type: 'SET_FORUM_CATEGORIES_LIST',
        payload: productCategories
      });
      categoriesDispatch({
        type: 'SET_SELECTED_CATEGORY',
        payload: productCategories[0]
      });
      categoriesDispatch({
        type: 'SET_ROOT_CATEGORY',
        payload: productCategories[0]
      });
    }
    return productCategories;
  };
  return {
    setEnvironmentVars,
    setCategories,
    authenticateUser,
    authPlatformUser,
    setAuthContextFromUser,
    setUserPreferences,
    getUserUnsubscribeOptions,
    setUserUnsubscribeOptions
  };
};
export { forumInterfaceFunctions };
//# sourceMappingURL=forumInterfaceFunctions.js.map